import { render, staticRenderFns } from "./StatisticCardVerticalUniqueComments.vue?vue&type=template&id=ca975c50&"
import script from "./StatisticCardVerticalUniqueComments.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalUniqueComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports